import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { PageSizeArr } from '@/constants/constants';

type TablePageSizeProps = {
  currentPageSize: number;
  onPageSizeChange: (newPageSize: number) => void;
};

const TablePageSize = ({ currentPageSize, onPageSizeChange }: TablePageSizeProps) => {
  const handlePageSizeChange = (e: SelectChangeEvent<number>) => {
    onPageSizeChange(+e.target.value);
  };

  return (
    <>
      <Typography>Items per page</Typography>
      <Select size="small" value={currentPageSize} onChange={handlePageSizeChange}>
        {PageSizeArr.map(({ key, value }) => (
          <MenuItem key={key} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default TablePageSize;
